import { TIMER_LIMIT } from '../utils';

export function createTimer(nameOfTimer, timerLimit = TIMER_LIMIT) {
    this[nameOfTimer] = {
        nextChange: null,
        changeTimer: null,
        changeSeconds: 0,
        clearChangeTimer: null,
        confirmChange: null,
        callFuncWithTimer: null,
        changeFunction: null,
    };
    function clearChangeTimer() {
        clearInterval(this[nameOfTimer]['changeTimer']);
        this.$set(this[nameOfTimer], 'nextChange', null);
        this.$set(this[nameOfTimer], 'changeSeconds', 0);
        this.$set(this[nameOfTimer], 'changeTimer', null);
        this.$set(this[nameOfTimer], 'changeFunction', null);
    }
    function confirmChange() {
        const func = this[nameOfTimer].changeFunction;
        const value = this[nameOfTimer].nextChange;
        this[nameOfTimer].clearChangeTimer();
        func(value);
    }
    function callFuncWithTimer(value, func) {
        this[nameOfTimer].clearChangeTimer();
        this.$set(this[nameOfTimer], 'nextChange', value);
        this.$set(this[nameOfTimer], 'changeFunction', func);
        this.$set(
            this[nameOfTimer],
            'changeTimer',
            setInterval(() => {
                this.$set(this[nameOfTimer], 'changeSeconds', this[nameOfTimer].changeSeconds + 1);
                if (this[nameOfTimer].changeSeconds >= timerLimit) {
                    this[nameOfTimer].clearChangeTimer();
                    func(value);
                }
            }, 1000),
        );
    }
    this.$set(this[nameOfTimer], 'callFuncWithTimer', callFuncWithTimer.bind(this));
    this.$set(this[nameOfTimer], 'clearChangeTimer', clearChangeTimer.bind(this));
    this.$set(this[nameOfTimer], 'confirmChange', confirmChange.bind(this));
}
